export const ReportsData = [
  {
    report_id: 1,
    report_title: "Total Sales",
    report_items: 19,
  },
  {
    report_id: 2,
    report_title: "Out of Stock Products",
    report_items: 19,
  },
  {
    report_id: 3,
    report_title: "Recent Orders",
    report_items: 19,
  },
  {
    report_id: 4,
    report_title: "Order to be Delivered",
    report_items: 19,
  },
  {
    report_id: 5,
    report_title: "Inventory",
    report_items: 19,
  },
  {
    report_id: 6,
    report_title: "Top Product Sold",
    report_items: 19,
  },
  {
    report_id: 7,
    report_title: "Average Order Value",
    report_items: 19,
  },
  {
    report_id: 8,
    report_title: "Earning And Commission Per Order",
    report_items: 19,
  },
];
